import { gql } from 'graphql-request'

export namespace FollowMutations {
  export function createFollowUp() {
    return gql`
      mutation createFollowUpTask($followUpTask: FollowUpTaskInsertMutation) {
        createFollowUpTask(followUpTask: $followUpTask) {
          id
        }
      }
    `
  }

  export function updateFollowUp() {
    return gql`
      mutation updateFollowUpTask($followUpTask: FollowUpTaskUpdateMutation) {
        updateFollowUpTask(followUpTask: $followUpTask) {
          id
        }
      }
    `
  }

  export function adjustFollowUpTaskDueDates() {
    return gql`
      mutation adjustFollowUpTaskDueDates($potentialBookingId: Int!, $nextDueDate: String!) {
        adjustFollowUpTaskDueDates(potentialBookingId: $potentialBookingId, nextDueDate: $nextDueDate) {
          id
        }
      }
    `
  }

  export function cancelFollowUp() {
    return gql`
      mutation cancelFollowUpTask($taskIds: [Int!]!) {
        cancelFollowUpTasks(taskIds: $taskIds) {
          id
        }
      }
    `
  }
}
